import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/material/styles';

// Components
import Typography from 'Components/ds/Typography';

const styles: { [key: string]: SxProps } = {
  feature: {
    p: 2,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '12px',
    backdropFilter: 'blur(6px)',
  },
};

interface FeatureProps {
  title: string;
  text: string;
  sx?: SxProps;
}

const Feature = ({ title, text, sx }: FeatureProps) => {
  const sxProp = { ...sx, ...styles.feature };

  return (
    <Stack spacing={1.5} sx={sxProp}>
      <Typography variant='h6' color='ds.text.contrast'>
        {title}
      </Typography>
      <Typography variant='paragraphMedium' color='ds.text.contrast'>
        {text}
      </Typography>
    </Stack>
  );
};

export default Feature;
